module.exports = __webpack_public_path__ + "static/media/service3.2357e0a7.png";